import React, { useState } from "react";
import { Card, Table, Button, Dropdown, Form, InputGroup, Row, Col } from "react-bootstrap";
import { FaPlus, FaRedo, FaFilter, FaSort, FaSearch, FaTh, FaList } from "react-icons/fa";


const initialData = [
    { name: "Academic Services", image: "https://via.placeholder.com/150", owner: "Admin User", modifiedBy: "Admin User", lastModified: "30 Aug 7:30 PM", status: "Active" },
    { name: "IT Services", image: "https://via.placeholder.com/150", owner: "Admin User", modifiedBy: "Admin User", lastModified: "30 Aug 7:30 PM", status: "Inactive" },
    { name: "Health Services", image: "https://via.placeholder.com/150", owner: "Admin User", modifiedBy: "Admin User", lastModified: "30 Aug 7:30 PM", status: "Active" },
    { name: "Library Services", image: "https://via.placeholder.com/150", owner: "Admin User", modifiedBy: "Admin User", lastModified: "30 Aug 7:30 PM", status: "Inactive" },
    // Add more entries as needed
  ];
const ServicesTable = () => {
  const [data, setData] = useState(initialData);
  const [searchQuery, setSearchQuery] = useState("");
  const [viewMode, setViewMode] = useState("table"); // 'table' or 'grid'
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = filteredData.slice(startIndex, startIndex + itemsPerPage);

  const pageCount = Math.ceil(filteredData.length / itemsPerPage);

  const handleToggleStatus = (index) => {
    const newData = [...data];
    const globalIndex = startIndex + index;
    newData[globalIndex].status =
      newData[globalIndex].status === "Active" ? "Inactive" : "Active";
    setData(newData);
  };

  return (
    <Card>
      <Card.Header className="d-flex justify-content-between align-items-center">
        <h3 variant="primary" className="d-flex align-items-center">
           Service
        </h3>
        <div className="d-flex align-items-center">
          <Button variant="light" className="me-2">
            <FaFilter />
          </Button>
          <Button variant="light" className="me-2">
            <FaRedo />
          </Button>
          <InputGroup style={{ width: "300px" }} className="me-2">
            <InputGroup.Text className="bg-white border-0">
              <FaSearch />
            </InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearch}
              className="rounded-pill"
            />
          </InputGroup>
          <Button
            variant="light"
            onClick={() => setViewMode(viewMode === "table" ? "grid" : "table")}
          >
            {viewMode === "table" ? <FaTh /> : <FaList />}
          </Button>
        </div>
      </Card.Header>
      <Card.Body>
        {viewMode === "table" ? (
          <div className="table-responsive border border-secondary rounded" style={{ padding: "1rem" }}>
            <Table hover>
              <thead>
                <tr>
                  <th>Name <FaSort /></th>
                  <th>Onwer <FaSort /></th>
                  <th>Last Modified <FaSort /></th>
                  <th> Modified By<FaSort /></th>
                  <th>Status <FaSort /></th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.name}</td>
                    <td>{item.owner}</td>
                    <td>{item.lastModified}</td>
                    <td>{item.modifiedBy}</td>
                    <td>
                      <span
                        className={`badge ${
                          item.status === "Active" ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {item.status}
                      </span>
                    </td>
                    <td>
                      <Dropdown>
                        <Dropdown.Toggle variant="light" size="sm" className="border-0">
                          Actions
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => handleToggleStatus(index)}
                          >
                            Toggle Status
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <Row>
            {paginatedData.map((item, index) => (
              <Col key={index} md={4} className="mb-4">
                <Card className="h-100">
                  <Card.Img
                    variant="top"
                    src={item.image}
                    alt={item.name}
                    style={{ height: "150px", objectFit: "cover" }}
                  />
                  <Card.Body className="d-flex justify-content-between align-items-center">
                    <Card.Title>{item.name}</Card.Title>
                    <Button
                      variant={
                        item.status === "Active" ? "success" : "danger"
                      }
                      size="sm"
                      onClick={() => handleToggleStatus(index)}
                    >
                      {item.status === "Active" ? "Active" : "Inactive"}
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <div>
            Showing {startIndex + 1} to {Math.min(startIndex + itemsPerPage, filteredData.length)} of{" "}
            {filteredData.length} entries
          </div>
          <div>
            {[...Array(pageCount).keys()].map((page) => (
              <Button
                key={page}
                variant="light"
                className={`me-1 ${currentPage === page + 1 ? "active" : ""}`}
                onClick={() => setCurrentPage(page + 1)}
              >
                {page + 1}
              </Button>
            ))}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ServicesTable;
